import { BlockedRecordBlockedType } from '@exam-center/graphql';
import { MIME_TYPES, type OptionSelectionProps } from '@shared/components';

// REMARK: keep this in this file instead of constants.ts to avoid circular dependency
export const DAYS_PER_MONTH = 30;
export const DAYS_PER_YEAR = 365;

export function formatDateUnitByDays(days: number): string {
  let remaining = days;
  const years = Math.floor(remaining / DAYS_PER_YEAR);
  remaining -= years * DAYS_PER_YEAR;
  const months = Math.floor(remaining / DAYS_PER_MONTH);
  remaining -= months * DAYS_PER_MONTH;
  const remainingDays = remaining;

  const parts: string[] = [];
  if (years > 0) parts.push(`${years} ปี`);
  if (months > 0) parts.push(`${months} เดือน`);
  if (remainingDays > 0) parts.push(`${remainingDays} วัน`);

  return parts.length > 0 ? parts.join(' ') : '0 วัน';
}

const BLOCKED_PERIODS_IN_DAYS = [
  3 * DAYS_PER_MONTH,
  6 * DAYS_PER_MONTH,
  1 * DAYS_PER_YEAR,
  2 * DAYS_PER_YEAR,
  3 * DAYS_PER_YEAR,
  5 * DAYS_PER_YEAR,
];

export const BLOCKED_PERIOD_OPTIONS: OptionSelectionProps[] = BLOCKED_PERIODS_IN_DAYS.map(
  (days) => ({
    label: formatDateUnitByDays(days),
    value: days,
  }),
);

export const COOL_DOWN_PERIOD_BY_BLOCKED_TYPE: Record<BlockedRecordBlockedType, number> = {
  [BlockedRecordBlockedType.Staff]: 2 * DAYS_PER_YEAR,
  [BlockedRecordBlockedType.Vendor]: 2 * DAYS_PER_YEAR,
  [BlockedRecordBlockedType.MysteryAudit]: 3 * DAYS_PER_MONTH,
  [BlockedRecordBlockedType.ExamCenterManager]: 1 * DAYS_PER_YEAR,
  [BlockedRecordBlockedType.Proctor_1]: 1 * DAYS_PER_YEAR,
  [BlockedRecordBlockedType.Proctor_2]: 6 * DAYS_PER_MONTH,
  [BlockedRecordBlockedType.Proctor_3]: 3 * DAYS_PER_MONTH,
  [BlockedRecordBlockedType.Instructor]: 3 * DAYS_PER_MONTH,
  // REMARK: Cheater type can selected multiple periods,
  // so we set cool down period to 2 years which is minimum
  // and handle this on future
  [BlockedRecordBlockedType.Cheater]: 2 * DAYS_PER_YEAR,
  // REMARK: Cool down period of exam passer, and other types is not defined here
  // since they cannot be manually blocked by admin users.
  [BlockedRecordBlockedType.ExamPasser]: 0,
  [BlockedRecordBlockedType.Other]: 0,
};

export const BLOCKED_ITEM_FORM_CONDITIONS = {
  MIN_REQUIRED_FIELD_LENGTH: 1,
  MAX_NAME_LENGTH: 100,
  MAX_EMAIL_LENGTH: 256,
  MAX_REASON_LENGTH: 1024,
  ALLOW_FILE_EXTENSIONS: [MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg] as string[],
  MAX_FILE_ATTACHMENTS: 4,
  MAX_TOTAL_ATTACH_FILE_SIZE_IN_MB: 20,
  MAX_TOTAL_ATTACH_FILE_SIZE_IN_BYTES: 20 * 1024 * 1024,
};

export const BLOCKED_TYPE_TEXT: Record<BlockedRecordBlockedType, string> = {
  [BlockedRecordBlockedType.Staff]: 'เจ้าหน้าที่ตลาดหลักทรัพย์',
  [BlockedRecordBlockedType.ExamCenterManager]: 'ผู้จัดการศูนย์ทดสอบ',
  [BlockedRecordBlockedType.Instructor]: 'วิทยากร',
  [BlockedRecordBlockedType.Vendor]: 'Vendor',
  [BlockedRecordBlockedType.MysteryAudit]: 'Mystery Audit',
  [BlockedRecordBlockedType.Proctor_1]: 'ผู้คุมสอบประเภทที่ 1',
  [BlockedRecordBlockedType.Proctor_2]: 'ผู้คุมสอบประเภทที่ 2',
  [BlockedRecordBlockedType.Proctor_3]: 'ผู้คุมสอบประเภทที่ 3',
  [BlockedRecordBlockedType.ExamPasser]: 'ผู้ที่สอบผ่าน',
  [BlockedRecordBlockedType.Cheater]: 'ผู้ที่ทุจริต',
  [BlockedRecordBlockedType.Other]: 'อื่น ๆ',
};

const CREATE_BLOCKED_TYPES = [
  BlockedRecordBlockedType.Staff,
  BlockedRecordBlockedType.ExamCenterManager,
  BlockedRecordBlockedType.Instructor,
  BlockedRecordBlockedType.Vendor,
  BlockedRecordBlockedType.MysteryAudit,
  BlockedRecordBlockedType.Cheater,
];

const getCreatableBlockedTypeOptions = () => {
  return CREATE_BLOCKED_TYPES.map<OptionSelectionProps>((type) => ({
    label: BLOCKED_TYPE_TEXT[type],
    value: type,
  }));
};
const getBlockedTypeOptions = () => {
  return Object.entries(BLOCKED_TYPE_TEXT).map<OptionSelectionProps>(([key, label]) => ({
    label,
    value: key as BlockedRecordBlockedType,
  }));
};

export const CREATABLE_BLOCKED_TYPE_OPTIONS = getCreatableBlockedTypeOptions();

export const BLOCKED_TYPE_OPTIONS = getBlockedTypeOptions();
